// Chakra imports
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import BarChart from 'components/charts/BarChart';

// Custom components
import Card from 'components/card/Card';
import { numberToHour } from 'utils';
import { barChartOptions } from 'variables/charts';

// Forfaits horaires actifs avec le moins d'heures restantes
export default function LowestRemaining(props: {
	labels: string[];
	remaining: number[];
	lowCount: number;
	[x: string]: any;
}) {
	const { labels, remaining, lowCount, ...rest } = props;

	// Chakra Color Mode
	const textColor = useColorModeValue('secondaryGray.900', 'white');

	const chartData = [ { name: 'Heures restantes', data: remaining } ];
	const chartOptions = {
		...barChartOptions,
		xaxis: {
			...barChartOptions.xaxis,
			categories: labels,
			labels: {
				...barChartOptions.xaxis.labels,
				rotate: -45,
				trim: true,
				maxHeight: 90,
				style: { ...barChartOptions.xaxis.labels.style, fontSize: '11px' }
			}
		},
		tooltip: { ...barChartOptions.tooltip, y: { formatter: numberToHour } }
	};

	return (
		<Card alignItems='center' flexDirection='column' w='100%' {...rest}>
			<Flex justify='space-between' align='start' px='10px' pt='5px' w='100%'>
				<Flex flexDirection='column' align='start' me='20px'>
					<Flex w='100%'>
						<Text me='auto' color='secondaryGray.600' fontSize='sm' fontWeight='500'>
							Forfaits les plus entamés
						</Text>
					</Flex>
					<Flex align='end'>
						<Text color={lowCount > 0 ? 'orange.500' : textColor} fontSize='34px' fontWeight='700' lineHeight='100%'>
							{lowCount}
						</Text>
						<Text ms='6px' color='secondaryGray.600' fontSize='sm' fontWeight='500'>
							à 1h ou moins
						</Text>
					</Flex>
				</Flex>
			</Flex>
			{labels.length > 0 ? (
				<Box h='240px' mt='auto' w='100%'>
					<BarChart chartData={chartData} chartOptions={chartOptions} />
				</Box>
			) : (
				<Text color='secondaryGray.600' fontSize='sm' my='auto'>
					Aucun forfait horaire actif
				</Text>
			)}
		</Card>
	);
}
